import Signal from '@/webgl/core/Signal'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import ScrollSystem from '@/webgl/runner/systems/ScrollSystem'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export default class Countdown implements IGameSegment {
  onComplete = new Signal<void>()
  timeout: number
  world: GameWorld

  constructor(
    readonly id: string = 'countdown',
    readonly duration: number = 3
  ) {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup): void {
    this.world = world
  }

  start(): void {
    this.world.systems.get<ScrollSystem>(ScrollSystem).enable()
    this.timeout = window.setTimeout(() => this.onComplete.emit(), this.duration * 1000)
  }

  stop(): void {
    window.clearTimeout(this.timeout)
  }
}
